<script>
export default {
  name: 'PageFooter',
  methods: {
    toHelperCenter(){
      this.$router.push({ name: 'helperCenter' })
    },
    // 关键节点：将顶部导航定位到首页对应内容区
    scrollToHomeSection(sectionId){
      const target = document.getElementById(sectionId)
      // 逻辑分支：目标区块不存在时直接结束，避免导航点击抛出异常
      if (!target) return
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
  }
}
</script>

<template>
<div class="footer">
  <div class="footer-info">
    <div class="left">
       <div class="web-company">
         <div class="logo"><img src="@/assets/images/logo.svg" alt=""></div>
         <div class="company">版权所有 © 杭州深蓝图景数智科技有限公司。保留一切权利。</div>
       </div>
    </div>
    <div class="center">
      <div class="links">
        <div class="links-item" @click="scrollToHomeSection('product-capability')">产品能力</div>
        <div class="links-item" @click="scrollToHomeSection('package-selection')">产品方案</div>
        <div class="links-item">客户案例</div>
        <div class="links-item" @click="toHelperCenter">常见问题</div>
        <div class="links-item">隐私协议</div>
        <div class="links-item">用户服务协议</div>
      </div>
    </div>
    <div class="right">
      <div class="contact">
        <div class="contact-us">联系我们</div>
        <div class="wechat-img"><img src="@/assets/images/icons/wechat.svg" alt=""></div>
        <div class="email-img"><img src="@/assets/images/icons/email.svg" alt=""></div>
      </div>
    </div>
  </div>
  <div class="website-copy">
    <img src="@/assets/images/icons/copy.svg" alt="">
    <a href="https://beian.mps.gov.cn/?spm=a21bo.jianhua/a.1997523009-ft.21.78632a89DpCynq#/query/webSearch" target="_blank">浙公网安备33010602014312号</a>
    <a href="https://beian.miit.gov.cn/?spm=a21bo.jianhua/a.1997523009-ft.23.78632a89DpCynq#/Integrated/index" target="_blank">浙ICP备2026004701号-1</a>
  </div>
</div>
</template>

<style scoped lang="less">
.footer{
  width: 1440px;
  height: 276px;
  margin: 0 auto;
  .website-copy{
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    color: #999;
    line-height: 16px;
    img{
      margin-right: 5px;
      display: block;
      width: 16px;
      height: 16px;
    }
    a{
      margin-right: 12px;
      &:last-child{
        margin-right: 0;
      }
    }
  }
}
.footer-info{
  width: 100%;
  height: 196px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 40px 120px 0;
  .left{
    .web-company{
      width: 387px;
      .logo{
        height: 28px;
        img{
          display: block;
          height: 28px;
        }
      }
      .company{
        font-weight: 400;
        font-size: 10px;
        line-height: 18px;
        text-align: left;
        color: #1d1d1d;
        margin-top: 20px;
      }
    }
  }
  .center{
    width: 691px;
    .links{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      .links-item{
        width: 158px;
        height: 22px;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        text-align: left;
        margin-bottom: 24px;
        cursor: pointer;
        color: #1d1d1d;
      }
    }
  }
  .right{
    text-align: center;
    .contact{
      width: 82px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      .contact-us{
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        color: #1d1d1d;
        margin-bottom: 20px;
        text-align: center;
      }
      .wechat-img{
        width: 27px;
        height: 22px;
        cursor: pointer;
        img{
          display: block;
          width: 27px;
          height: 22px;
        }
      }
      .email-img{
        width: 34px;
        height: 31px;
        margin-top: 27px;
        cursor: pointer;
        img{
          display: block;
          width: 34px;
          height: 31px;
        }
      }
    }
  }
}
</style>
